import { Navbar } from "react-bootstrap";
import ContactUsHero from "../../components/ContactUs/ContactUsHero";
import SendMessage, {
  ContactFormValues,
} from "../../components/ContactUs/SendMessage";
import Footer from "../../components/Footer/Footer";
import CommonQuestion from "../../components/ContactUs/CommonQuestion";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setError, setLoading } from "../../store/auth/authSlice";
import { toast } from "react-toastify";

function ContactUs() {
  const [formData, setFormData] = useState<ContactFormValues>({
    fullName: "",
    email: "",
    title: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined); // Change null to undefined

  const dispatch = useDispatch();

  const handleForm = () => {
    // Here you can dispatch an action to handle form submission
    // For example:
    // dispatch(setLoading(true));
    // API call or any async operation can be performed here
    // After completion, you can dispatch setLoading(false) and setError(undefined)
    // You can also show success/failure messages using toast
    // Example:
    // toast.success("Message sent successfully!");
    // toast.error("Failed to send message. Please try again.");
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleForm();
  };

  return (
    <div className="Landing-page-all">
      <Navbar />
      <ContactUsHero />
      <SendMessage
        handleForm={handleForm}
        formData={formData}
        setFormData={setFormData}
        isLoading={loading}
        errorMessage={error}
      />
      <CommonQuestion />
      <Footer />
    </div>
  );
}

export default ContactUs;
